/** Restore the consolidated tour without moving returning users to a different feature. */
export function restoredTourIndex(current: string | null, legacy: string | null, count: number): number {
  const stored = current ?? legacy;
  if (stored === null || stored.trim() === '') return -1;
  let index = Number(stored);
  if (!Number.isInteger(index)) return -1;
  if (current === null && index > 0) index -= 1; // Old brand steps 0 and 1 now share step 0.
  return index >= -1 && index < count ? index : -1;
}

/** v3 teaches brand selection before writing a brief; resume the same lesson. */
export function restoredRefreshedTourIndex(current: string | null, previous: string | null, legacy: string | null, count: number): number {
  if (current !== null) return restoredTourIndex(current, null, count);
  const index = restoredTourIndex(previous, legacy, count);
  return index === 1 ? 2 : index === 2 ? 1 : index;
}
